// TourContext.jsx
import React, { createContext, useContext, useState } from 'react';
import TourModal from './TourModal';

const TourContext = createContext();

export const useTour = () => {
  const context = useContext(TourContext);
  if (!context) {
    throw new Error('useTour must be used within a TourProvider');
  }
  return context;
};

const chaveTourVisto = (email) => `tourVisto_${email}`;

export const TourProvider = ({ children }) => {
  const [tourAberto, setTourAberto] = useState(false);
  const [passoAtual, setPassoAtual] = useState(0);
  const [emailUsuario, setEmailUsuario] = useState(null);

  const abrirTour = () => {
    setPassoAtual(0);
    setTourAberto(true);
  };

  const fecharTour = () => {
    setTourAberto(false);
    if (emailUsuario) {
      localStorage.setItem(chaveTourVisto(emailUsuario), 'true');
    }
  };

  // Chamado no primeiro useEffect de cada tela após login (ex: HomePage) com o email do usuário logado
  const verificarPrimeiroAcesso = (email) => {
    if (!email) return;
    setEmailUsuario(email);
    if (!localStorage.getItem(chaveTourVisto(email))) {
      abrirTour();
    }
  };

  return (
    <TourContext.Provider value={{ abrirTour, fecharTour, verificarPrimeiroAcesso }}>
      {children}
      {tourAberto && (
        <TourModal
          passoAtual={passoAtual}
          setPassoAtual={setPassoAtual}
          onFechar={fecharTour}
        />
      )}
    </TourContext.Provider>
  );
};
